/**
 * Cameroon phone number validation (mobile money payouts).
 *
 * Rules per spec §13:
 *   - International form: `+237` + `6XXXXXXXX` or `+237` + `5XXXXXXXX`  (9 digits after country code)
 *   - National form (no `+237`): also accepted; we normalize back to international.
 *   - Spaces and dashes tolerated; stripped during normalize.
 */

const PREFIX = '+237';
const NATIONAL_RE = /^[56]\d{8}$/;

export function normalizeCameroonPhone(input: string): string {
  if (typeof input !== 'string') return '';
  const cleaned = input.replace(/[\s-]/g, '');
  if (cleaned.startsWith('+237')) return cleaned;
  if (cleaned.startsWith('00237')) return `+${cleaned.slice(2)}`;
  if (cleaned.startsWith('237')) return `+${cleaned}`;
  return `${PREFIX}${cleaned}`;
}

export function isValidCameroonPhone(input: string): boolean {
  if (typeof input !== 'string' || input.length === 0) return false;
  const normalized = normalizeCameroonPhone(input);
  if (!normalized.startsWith(PREFIX)) return false;
  const national = normalized.slice(PREFIX.length);
  return NATIONAL_RE.test(national);
}

export function formatCameroonPhone(input: string): string {
  const n = normalizeCameroonPhone(input);
  if (!isValidCameroonPhone(n)) return n;
  // +237 6XX XX XX XX
  const national = n.slice(4);
  return `${PREFIX} ${national.slice(0, 3)} ${national.slice(3, 5)} ${national.slice(5, 7)} ${national.slice(7)}`;
}
